import $ from 'jquery';
import _ from 'underscore';
import * as eventEmitter from '../core/eventEmmiter';
import ValidationView from './validationView';

let validationRules = {};

const validation = {
    remoteMethodDelay: 500,

    /**
     * Initialize validation for each form
     */
    initialize: function () {
        this.setDelayToRemoteMethod();
        this.initializeValidation();
    },

    initializeValidation: function () {
        var $forms = $(document).find('form[data-validate="true"]').filter(function () {
            return !Boolean($(this).closest('.lightbox-block').length);
        });

        _.each($forms, function (form) {
            new ValidationView({
                el: form,
                validationRules
            });
        });
    },

    /**
     * Reload validation for each form
     */

    reload: function () {
        this.initializeValidation();
        eventEmitter.trigger('validationReload');
    },

    /**
     * Get generated rules
     * @param {string|string[]} fieldName
     * @param {string} [formValidatorId]
     * @returns {Object}
     */
    getRules: function (fieldName, formValidatorId) {
        this.validationView = this.validationView || new ValidationView({
            validationRules
        });

        return this.validationView.getRules(fieldName, formValidatorId);
    },

    setDelayToRemoteMethod: function () {
        $.validator.methods._remote = $.validator.methods.remote; // eslint-disable-line no-underscore-dangle

        var timer = 0;

        $.validator.methods.remote = function () {
            clearTimeout(timer);

            var args = arguments;

            timer = setTimeout($.proxy(function () {
                $.validator.methods._remote.apply(this, args); // eslint-disable-line no-underscore-dangle
            }, this), this.remoteMethodDelay);

            return 'pending';
        };
    }
};

export function initialize(rules) {
    validationRules = rules;
    validation.initialize();
}

export function reload() {
    return validation.reload();
}

export function getRules(fieldName, formValidatorId) {
    return validation.getRules(fieldName, formValidatorId);
}

/**
 * @description passes lightbox to the window
 * currently it's being used by b2b
 * look @https://github.com/Home24/Shop-LandingPages
 * @method exportValidationToWindow
 * @returns {undefined}
 */
export function exportValidationToWindow() {
    const w = window;

    w.home24 = w.home24 || {};

    w.home24.validation = validation;
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/validation/validation-controller.js
 **/